'use strict';

import React, { useCallback, useState } from 'react';
import { connect } from 'react-redux';

import { appSelectors, appOperations } from '@/state/domains/app';
import { usersOperations, usersSelectors } from '@/state/domains/users';
import { locationListSelectors, locationListOperations } from '@/state/domains/locationList';
import { attemptsOperations, attemptsSelectors } from '@/state/domains/attempts';
import { assignmentsSelectors, assignmentsOperations } from '@/state/domains/assignments';

import Item from './Item';

import s from './styles.scss';

const List = ({
	user,
	username,
	date,
	urlParams,
	locationList,
	attempts,
	assignments,
	postReorderedLocations,
	toggleSelect,
	postFlagIncrement,
	postPriorityIncrement,
	reorderAssigned,
	isMobile,
	canEdit,
	expanded,
}) => {

	/*const styles = {
		height: window.innerHeight - 55 - 45 + 'px'
	};*/

	const moveOrder = useCallback((dragIndex, hoverIndex) => {

		reorderAssigned(dragIndex, hoverIndex);

	}, []);

	const renderItem = useCallback((listItem, index) => {

		//const job = listItem.jobs[ 0 ];
		//const isAttempted = !!attempts.find(a => a.jobId == job.id);
		//const userJob = user.assigned[ date ].jobs.find(j => j.id === job.id);
		const isAttempted = false;
		const jobId = listItem.jobs.length ? listItem.jobs[ 0 ] : undefined;
		
		return <Item
			key={ index }
			index={ index }
			expanded={ expanded }
			listItem={ listItem }
			locationId={ listItem.locationId }
			jobId={ jobId }
			jobIds={ listItem.jobs }
			attempts={ attempts }
			index={ index }
			moveOrder={ moveOrder }
			user={ user }
			date={ date }
			locationList={ locationList }
			urlParams={ urlParams }
			postReorderedLocations={ postReorderedLocations }
			isAttempted={ isAttempted }
			isSelected={ listItem.isChecked }
			toggleSelected={ toggleSelect }
			postFlagIncrement={ idx => postFlagIncrement(username, date, idx) }
			postPriorityIncrement={ idx => postPriorityIncrement(username, date, idx) }
			isMobile={ isMobile }
			canEdit={ canEdit }
		/>;
	});

	return (
		<table className={ s.jobList }>
			<colgroup>
				<col />
				<col />
				{ canEdit && <col /> }
				<col />
				{ canEdit && <col span="4" className={ s.actionsCol } /> }
				<col />
			</colgroup>
			<thead>
				<tr>
					<th />
					{ canEdit && <th className={ s.check }/> }
					<th className={ s.num } />
					<th className={ s.address } />
					{ canEdit && (
						<>
							<th />
							<th />
							<th />
							<th />
						</>
					)}
					<th />
				</tr>
			</thead>
			{ locationList.map((listItem, i) => renderItem(listItem, i))}
		</table>
	);
};

export default connect(
	(state, props) => ({
		isMobile: appSelectors.isMobile(state, props),
		urlParams: appSelectors.getUrlParams(state, props),
		date: appSelectors.getPageDate(state, props),
		username: appSelectors.getPageUsername(state, props),
		user: usersSelectors.getPageUser(state, props),
		locationList: locationListSelectors.getList(state, props),
		attempts: attemptsSelectors.getDailyAttempts(state, props),
		assignments: assignmentsSelectors.getPageUserDayAssignments(state, props),
	}),
	{
		toggleSelect: locationListOperations.toggleSelect,
		reorderAssigned: locationListOperations.reorderAssigned,
		postFlagIncrement: locationListOperations.postFlagIncrement,
		postPriorityIncrement: locationListOperations.postPriorityIncrement,
		postReorderedLocations: locationListOperations.postReorderedLocations,
	}
)(List);
